import { Modal, ModalCloseButton, ModalConfirmButton, ModalWidth, StyledFlex, Text } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { historicalVisitTranslationKeys } from '../../../../translations';
import { CopiedPrescription, NotCopiedPrescriptionSummaryItem } from '../copyPrescription.types';

import { CopySummaryTable } from './CopySummaryTable';

const t = historicalVisitTranslationKeys.copyPrescription;

type CopySummaryModalProps = {
   readonly copiedPrescriptions: CopiedPrescription[];
   readonly notCopiedSummaryItems: NotCopiedPrescriptionSummaryItem[];
   readonly onClose: VoidFunction;
   readonly onReplace: (item: NotCopiedPrescriptionSummaryItem) => void;
};

export const CopySummaryModal = (props: CopySummaryModalProps): JSX.Element => {
   return (
      <Modal testId={'copySummary'} title={t.copySummaryTitle} onCloseRequest={props.onClose} width={ModalWidth.NORMAL}>
         <StyledFlex direction={'column'} gap={'16px'}>
            <Text testId={'copySummaryDescription'}>
               <Translate>{t.copySummaryDescription}</Translate>
            </Text>
            <CopySummaryTable
               copiedPrescriptions={props.copiedPrescriptions}
               notCopiedSummaryItems={props.notCopiedSummaryItems}
               onReplace={props.onReplace}
            />
         </StyledFlex>

         <ModalConfirmButton label={t.close} onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
